import { call, put, takeLatest } from 'redux-saga/effects';

import { userApi } from '../../../api';

import { updateQueryString } from '../../router/actions';
import { pushNotification } from '../../ui/actions';

import * as actions from './actions';

function* signup({ payload }) {
  try {
    yield put({ type: actions.SIGNUP_PENDING });
    const { status } = yield call(userApi.signup, payload);

    if (status === 200) {
      yield put({ type: actions.SIGNUP_FULFILLED });
      yield put(updateQueryString({ modal: undefined }));
      yield put(
        pushNotification({
          title: 'Activation email sent',
          description: 'Please click the activation link to complete your registration.',
          duration: 0,
        }),
      );
    }
  } catch (e) {
    yield put({ type: actions.SIGNUP_REJECTED, payload: e });
  }
}

export function* watchSignup() {
  yield takeLatest(actions.SIGNUP, signup);
}
